export default "__VITE_ASSET__DgppA7sW__"